import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Bookmark } from "lucide-react";
import Navbar from "@/components/Navbar";
import JobCard from "@/components/JobCard";
import JobDrawer from "@/components/JobDrawer";
import useJobActions from "@/hooks/useJobActions";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";

export default function Saved() {
  const { t } = useTranslation();
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selected, setSelected] = useState(null);
  const { savedIds, appliedIds, toggleSave, apply } = useJobActions();

  const load = async () => {
    setLoading(true);
    try { const { data } = await api.get("/saved"); setJobs(data); } finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);

  const handleToggle = async (job) => {
    await toggleSave(job);
    setJobs((prev) => prev.filter((j) => j.id !== job.id));
  };

  return (
    <div className="min-h-screen wo-bg">
      <Navbar />
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-8 pb-28 lg:pb-8">
        <h1 className="font-display font-bold text-3xl text-slate-100 flex items-center gap-3"><Bookmark className="text-teal-400" /> {t("page.savedJobs")}</h1>
        <p className="text-slate-400 text-sm mt-1 mb-6">{jobs.length} {t("page.savedN")}</p>

        {loading ? (
          <p className="text-slate-500">{t("radar.scanning")}</p>
        ) : jobs.length === 0 ? (
          <div className="liquid-glass rounded-2xl p-12 text-center" data-testid="saved-empty">
            <Bookmark size={40} className="mx-auto text-slate-600 mb-4" />
            <p className="text-slate-400">{t("page.noSaved")}</p>
            <Link to="/radar"><Button className="mt-5 bg-gradient-to-r from-teal-400 to-cyan-500 text-slate-900 font-semibold">{t("page.scanRadar")}</Button></Link>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {jobs.map((job) => (
              <JobCard key={job.id} job={job} saved onToggleSave={handleToggle} onOpen={setSelected} />
            ))}
          </div>
        )}
      </div>

      <JobDrawer job={selected} open={!!selected} onClose={() => setSelected(null)}
        saved={selected && savedIds.includes(selected.id)} onToggleSave={toggleSave} onApply={apply}
        applied={selected && appliedIds.includes(selected.id)} />
    </div>
  );
}
